import React, { useCallback, useMemo } from 'react';
import PageLayout from '../../components/PageLayout';
import { useSchoolContext } from '../../../common/Context';
import GonorarBlock from '../../components/GonorarBlock';

export default function SchoolComissionGonorar(props) {
    const [school, setSchool] = useSchoolContext();
    const x = useMemo(()=>({organizatorShkolaID: school?.ID}),[school])
    // const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"], true));
    // const auth = useAuth()

    return (
        <PageLayout>
             <div style={{ padding: "10px" }}>
            <GonorarBlock {...props} source={"/api/shablonisudeiskikhgonorarov/list/school"}
                sourceKey="school"
                create={true}
                ctx={x}
            />
            </div>
        </PageLayout>
    );
}
